import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Text, Button } from '@hub-la/design-system';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContainerShadow } from '../container-shadow.js';

const CollaboratorsListEmptyState = ({
  isLoading
}) => {
  const history = useHistory();
  const {
    t
  } = useTranslation();
  return jsxs(ContainerShadow, {
    children: [jsx(Text, Object.assign({
      variant: "h4",
      mb: 2
    }, {
      children: t('collaboratorsList.emptyState.title')
    })), jsx(Text, Object.assign({
      variant: "body1",
      mb: 6
    }, {
      children: t('collaboratorsList.emptyState.description')
    })), jsx(Button, Object.assign({
      startIcon: jsx(AddIcon, {}),
      loading: isLoading,
      onClick: () => history.push('/collaborators/create')
    }, {
      children: t('collaboratorsList.emptyState.button')
    }))]
  });
};

export { CollaboratorsListEmptyState };
